// axiosInterceptor.js

import axios from 'axios';

// Maak een nieuwe instantie van axios
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL, // Vervang dit door je API-URL
});

// 👇 Extra instantie zonder interceptors voor refresh
const refreshInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

// Interceptor voor verzoeken
axiosInstance.interceptors.request.use(
  (config) => {
    // Haal de tokens uit localStorage of een andere opslagmethode
    const accessToken = localStorage.getItem('accessToken');
    
    // Voeg de access token toe aan de Authorization header
    if (accessToken) {
      config.headers['Authorization'] = `Bearer ${accessToken}`;
    }
    
    return config;
  },
  (error) => {
    // Behandel eventuele fouten bij het verzenden van het verzoek
    return Promise.reject(error);
  }
);

// Interceptor voor antwoorden
axiosInstance.interceptors.response.use(
  (response) => {
    // Verwerk de succesvolle respons
    return response.data;
  },
  async (error) => {
    const originalRequest = error.config;

    // Controleer of de fout een 401 (Unauthorized) is of een 403 (Forbidden)
    if ((error.response.status === 401 || error.response.status === 403) && !originalRequest._retry) {
      originalRequest._retry = true; // voorkom dubbele retry

      // Haal de refresh token op
      const rt = localStorage.getItem('refreshToken');
      
      if (rt) {
        
        try {
          // Probeer de access token te vernieuwen
          const response = await refreshInstance.post('/auth/refresh', { token: rt });
          const { accessToken, refreshToken } = response.data;

          // Sla de nieuwe access token op
          localStorage.setItem('accessToken', accessToken);
          localStorage.setItem('refreshToken', refreshToken);

          // Herhaal het oorspronkelijke verzoek met de nieuwe access token
          originalRequest.headers['Authorization'] = `Bearer ${accessToken}`;

          return axiosInstance(originalRequest).then(response => response);

        } catch (refreshError) {
          // Als de refresh token ook ongeldig is, stuur de gebruiker naar /login
          localStorage.removeItem('accessToken');
          localStorage.removeItem('refreshToken');
          localStorage.removeItem('bibloUser');
          window.location.href = '/login';
        }
      } else {
        // Als er geen refresh token is, stuur de gebruiker naar /login
        window.location.href = '/login';
      }
    }

    // Behandel andere fouten
    return Promise.reject(error);
  }
);

export default axiosInstance;
